import { AlertCircle, RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";

export const ErrorState = ({
  title = "Something went wrong",
  message,
  onRetry,
  retryLabel = "Try Again",
  testId = "error-state",
  className,
}) => (
  <div
    className={cn(
      "border border-analytics-red/40 bg-analytics-red/5 p-10 sm:p-16 text-center rounded-md min-w-0",
      className
    )}
    role="alert"
    data-testid={testId}
  >
    <div className="w-14 h-14 mx-auto border border-analytics-red/50 rounded-md flex items-center justify-center mb-4">
      <AlertCircle className="w-7 h-7 text-analytics-red" strokeWidth={1.5} aria-hidden="true" />
    </div>
    <h3 className="font-heading text-2xl sm:text-3xl tracking-wider uppercase text-dark-text-primary">{title}</h3>
    {message ? <p className="text-sm text-dark-text-secondary mt-3 max-w-md mx-auto">{message}</p> : null}
    {onRetry ? (
      <button
        type="button"
        onClick={onRetry}
        className="mt-6 inline-flex items-center gap-2 border border-dark-border hover:border-brand-primary transition-colors px-6 py-3 text-xs tracking-[0.2em] uppercase font-semibold min-h-[44px] rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary"
        data-testid={`${testId}-retry`}
      >
        <RefreshCw className="w-4 h-4" strokeWidth={2} aria-hidden="true" />
        {retryLabel}
      </button>
    ) : null}
  </div>
);
